module.exports = __webpack_public_path__ + "img/Best of Waadt weiss.5c0c9b74.jpg";